import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Alert,
  TextField,
} from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";

function ContractTerminateStatusDialog({
  open,
  onClose,
  contract,
  onTerminateSuccess,
}) {
  const [terminateInput, setTerminateInput] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);

  const isActiveContract = contract?.status === "ACTIVE";

  const handleTerminateClick = () => {
    if (isActiveContract) {
      setShowConfirmation(true);
    } else {
      handleConfirm();
    }
  };

  const handleConfirmClick = () => {
    if (terminateInput === "TERMINATE") {
      handleConfirm();
    }
  };

  const handleConfirm = () => {
    onTerminateSuccess();
    setTerminateInput("");
    setShowConfirmation(false);
  };

  const handleDialogClose = () => {
    setTerminateInput("");
    setShowConfirmation(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleDialogClose} maxWidth="sm" fullWidth>
      <DialogTitle>Terminate Contract</DialogTitle>
      <DialogContent>
        {isActiveContract && (
          <Alert severity="warning" icon={<WarningIcon />} sx={{ mb: 2 }}>
            <strong>Warning:</strong> This is an active contract. Terminating it
            may impact ongoing services. Are you sure you want to proceed?
          </Alert>
        )}
        <DialogContentText sx={{ mb: 2 }}>
          Are you sure you want to terminate contract{" "}
          <strong>{contract?.contract_id || contract?.id}</strong>? The status
          will be set to <strong>TERMINATED</strong> once you save.
        </DialogContentText>
        {isActiveContract && showConfirmation && (
          <TextField
            autoFocus
            margin="dense"
            label="Type TERMINATE to confirm"
            fullWidth
            variant="outlined"
            value={terminateInput}
            onChange={(e) => setTerminateInput(e.target.value)}
            placeholder="Type TERMINATE"
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDialogClose}>Cancel</Button>
        <Button
          onClick={showConfirmation ? handleConfirmClick : handleTerminateClick}
          color="error"
          variant="contained"
          disabled={
            isActiveContract &&
            showConfirmation &&
            terminateInput !== "TERMINATE"
          }
        >
          {isActiveContract && !showConfirmation
            ? "Terminate"
            : "Confirm Terminate"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ContractTerminateStatusDialog;